import { axios } from '@/lib/axios';

export const getDrmPfInformationList = ( order: string ) => {
  return axios.get('/api/v1/drmPfInformation/getList', {
    params: { order }
  })
}

export const getDrmPfInformation = ( id: number ) => {
  return axios.get('/api/v1/drmPfInformation/getInformation', {
    params: { id }
  })
}

export const getSearchConditionList = () =>{
  return axios.get('/api/v1/drmPfInformation/searchInputs')
}